import { queryOptions } from '@tanstack/react-query';
import fetchClient from '@eureca/admin-api-sdk/client';
import type { GetAssessments200 } from '@eureca/admin-api-sdk/types';

export type AssessmentListEntry = GetAssessments200['items'][number];

export class AssessmentsFetchError extends Error {
  readonly name = 'AssessmentsFetchError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

const STALE_TIME_MS = 60_000;

export const ASSESSMENTS_LIST_KEY = ['admin', 'assessments'] as const;

export function assessmentsListQueryKey() {
  return [...ASSESSMENTS_LIST_KEY, 'list'] as const;
}

/**
 * Biblioteca completa de assessments (`GET /assessments`, sem paginação no Core).
 * A tela separa client-side por `kind`: `preset_*` (instrumentos de fábrica) vs
 * `ad_hoc`. Config de PLATAFORMA — sem contexto de empresa.
 */
export function assessmentsListQueryOptions() {
  return queryOptions({
    queryKey: assessmentsListQueryKey(),
    queryFn: async ({ signal }) => {
      const res = await fetchClient<GetAssessments200>({
        method: 'GET',
        url: '/assessments',
        signal,
      });
      if (res.error) {
        throw new AssessmentsFetchError(
          `Failed to load assessments (status ${res.error.status})`,
          res.error.status
        );
      }
      return res.data;
    },
    staleTime: STALE_TIME_MS,
    retry: (failureCount, err) => {
      if (err instanceof AssessmentsFetchError && err.status >= 400 && err.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
